import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Privacy() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-white">
        <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-10">
            SOCIAL TRIP プライバシーポリシー
          </h1>

          <p className="text-gray-700 leading-relaxed mb-8">
            Force Agent合同会社（以下「当社」）は、当社が提供するアプリケーション「SOCIAL TRIP」（以下「本サービス」）におけるユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」）を定めます。
          </p>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第1条（収集する情報）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">当社は、ユーザーが本サービスを利用するにあたり、以下の情報を取得する場合があります。</p>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>ユーザーが登録する情報
                <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                  <li>氏名、メールアドレス、電話番号（任意）</li>
                  <li>プロフィール情報（ニックネーム、アイコン画像 等）</li>
                  <li>旅程情報（旅のしおり内容、訪問予定地 等）</li>
                </ul>
              </li>
              <li>利用状況に関する情報
                <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                  <li>アプリの利用履歴（AIプランナー利用回数、しおり作成履歴、閲覧した人気プラン 等）</li>
                  <li>検索・閲覧履歴、イベント通知設定状況</li>
                </ul>
              </li>
              <li>端末情報・ログ情報
                <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                  <li>端末種別、OS、識別子（広告ID 等）</li>
                  <li>IPアドレス、クッキー情報、位置情報（同意がある場合に限る）</li>
                </ul>
              </li>
              <li>連携サービスから取得する情報
                <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                  <li>航空券・ホテル予約検索時に必要なデータ（外部APIの利用状況）</li>
                  <li>SNS連携を行った場合の公開プロフィール情報</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第2条（利用目的）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">当社は、取得した情報を以下の目的で利用します。</p>
            <ol className="list-decimal list-inside space-y-1 text-gray-700 leading-relaxed">
              <li>本サービスの提供・運営のため</li>
              <li>旅行プラン提案（AIプランナー）・しおり管理・共有機能の提供のため</li>
              <li>航空券・ホテル・イベント等の外部サービス連携のため</li>
              <li>人気プラン覗き見機能・イベント通知機能の最適化のため</li>
              <li>SOS/セーフティアラート配信（位置情報・旅程連動通知）のため</li>
              <li>ユーザーサポート・お問い合わせ対応のため</li>
              <li>利用規約違反や不正利用防止のため</li>
              <li>利用動向の分析、サービス改善、新機能開発のため</li>
              <li>広告配信、マーケティングのため（同意がある場合に限る）</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第3条（第三者提供）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">当社は、取得した個人情報を、以下の場合を除き第三者に提供しません。</p>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>ユーザー本人の同意がある場合</li>
              <li>法令に基づく場合</li>
              <li>人の生命・身体・財産保護のために必要であり、本人の同意を得ることが困難な場合</li>
              <li>業務委託先（サーバー運営会社、決済代行業者 等）に提供する場合</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第4条（外部サービスの利用）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">本サービスは、以下の外部サービスと連携する場合があります。</p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 leading-relaxed ml-4">
              <li>Skyscanner、Booking.com、agoda 等のOTAサービス</li>
              <li>Amadeus API、FlightAPI.io 等の航空券検索API</li>
              <li>GDACS（国連・欧州委員会運営の災害情報システム）</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              外部サービスに遷移する際は、それぞれのサービスのプライバシーポリシーが適用されます。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第5条（情報の管理）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>当社は、個人情報の漏えい、滅失、毀損を防止するために適切なセキュリティ対策を講じます。</li>
              <li>ユーザーのデータは、日本国内または信頼できるクラウドサービス上に安全に保存されます。</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第6条（情報の保存期間）</h2>
            <p className="text-gray-700 leading-relaxed">
              ユーザー情報は、利用目的の達成に必要な範囲で保存し、目的達成後は速やかに削除します。ただし、法令で保存が義務付けられている場合はこの限りではありません。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第7条（ユーザーの権利）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">ユーザーは、当社に対して以下を請求することができます。</p>
            <ol className="list-decimal list-inside space-y-1 text-gray-700 leading-relaxed">
              <li>個人情報の開示</li>
              <li>訂正、追加、削除</li>
              <li>利用停止、消去、第三者提供の停止</li>
            </ol>
            <p className="text-gray-700 leading-relaxed mt-4">
              これらの請求があった場合、当社は法令に従って速やかに対応します。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第8条（未成年者の利用）</h2>
            <p className="text-gray-700 leading-relaxed">
              未成年者が本サービスを利用する場合、保護者の同意を得たものとみなします。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第9条（プライバシーポリシーの変更）</h2>
            <p className="text-gray-700 leading-relaxed">
              当社は、必要に応じて本ポリシーを改訂することがあります。改訂後は、本サービス上または当社ウェブサイトに掲示することにより効力を生じるものとします。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第10条（お問い合わせ窓口）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">本ポリシーに関するお問い合わせは、以下の窓口までお願いいたします。</p>
            <ul className="list-none space-y-1 text-gray-700 leading-relaxed">
              <li><span className="font-medium">会社名：</span>Force Agent合同会社</li>
              <li><span className="font-medium">メールアドレス：</span><a href="mailto:support@socialtrip.jp" className="text-[#02D0F0] hover:underline">support@socialtrip.jp</a></li>
              <li><span className="font-medium">所在地：</span>東京都港区海岸3-21-9</li>
            </ul>
          </section>
        </article>
      </main>
      <Footer />
    </>
  );
}
